import appModuleRegistry from "components/appModules/appModuleRegistry";
import { ComponentDefinition, PostRenderedComponent } from "components/components/Component";
import sislogUserGlobals from "components/UserGlobals";
import { MenuElement } from "./menuElement";
import Mousetrap from "mousetrap";
import { MenuEntry } from "./menuEntry";

export class SideMenu implements PostRenderedComponent {
    public componentType = "menu";
    public id;
    public definition: MenuDefinition;
    public view: MenuElement;

    constructor(definition: MenuDefinition) {
        this.definition = definition;
    }

    public render(): Element {
        let appPrefix = "";
        if (appModuleRegistry.currentApp != null) {
            appPrefix = appModuleRegistry.currentApp.prefix;
        }

        let d = document.createElement("s6-menu");
        (d as MenuElement).setMenu({
            ...this.definition,
            environment: sislogUserGlobals.appEnvironment,
            appPrefix,
            level: 0
        });

        this.view = (d as MenuElement);
        return this.view;
    }

    public focus() {
        this.view.focus();
    }

    public postRender(): void {
        Mousetrap.bind(['ctrl+m'], () => {
            this.focus();
            return false;
        });
    }
}

export interface MenuDefinition extends MenuEntries, ComponentDefinition {
}

export interface MenuEntries {
    entries: MenuEntry[];
}
